<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.7501 7.75495V7C1.7501 4.10051 4.10061 1.75 7.0001 1.75C9.8996 1.75 12.2501 4.10051 12.2501 7C12.2501 9.89949 9.8996 12.25 7.0001 12.25C5.47458 12.25 4.10102 11.5993 3.14181 10.5604M8.7501 5.78329C8.7501 5.23725 8.05391 4.6334 7.0001 4.6334M7.0001 4.6334C5.94629 4.6334 5.25023 5.12919 5.2501 5.78329C5.24997 6.43738 6.06646 6.75531 7.05382 6.9474C8.08977 7.14894 8.7501 7.47965 8.7501 8.08334C8.7501 8.72273 8.07177 9.17119 7.0001 9.17119M7.0001 4.6334V3.28907M7.0001 9.17119C5.92843 9.17119 5.2501 8.7013 5.2501 8.08334M7.0001 9.17119V10.7109M2.72717 7C2.72717 7.53964 2.2897 7.97711 1.75006 7.97711C1.21042 7.97711 0.772949 7.53964 0.772949 7C0.772949 6.46036 1.21042 6.02289 1.75006 6.02289C2.2897 6.02289 2.72717 6.46036 2.72717 7Z"
      stroke="var(--icon-border-default)"
      stroke-width="1.1"
    />
  </svg>
</template>
